import React, { useEffect, useState } from 'react';
import '../components/app.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import human2 from '../assets/team-2.jpg';
import human from '../assets/team-3.jpg';
import landingScreen from '../assets/screen9.jpg';
import landingScreen2 from '../assets/screen5.jpg';
import landingScreen4 from '../assets/screen8.jpg';
import landingScreen5 from '../assets/screen20.jpg';
import phonCase from '../assets/phone.png';
import pineapple from '../assets/logos/crop8.png';
import onions from '../assets//logos/crop200.png';
import yam from '../assets/logos/crop44.png';
import coacoa from '../assets/logos/crop2.png';

export default function HeroSection() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  
  const phoneImages = [
    landingScreen5,
    landingScreen,
    landingScreen2,
    landingScreen4
    
  ];
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  useEffect(() => {
   
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === phoneImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); 
    
    return () => clearInterval(interval); // Clean up interval on unmount
  }, [phoneImages.length]);

  return (
    <div className="mainfp">
      <div className='main-hero'>
        <div className="hero-content">
          <div className="top-btn">
            <span>
              <a href="#">Farmer</a>
              <a href="#">Try out our AI</a>
            </span>
          </div>
          <div className="hero-text text-left">
            <h1 className={isLoaded ? 'fade-in-up' : ''}>
              Connecting Farmers
             <span> to Prosperity</span>
            </h1>
           
            <p className={isLoaded ? 'fade-in-up' : ''} style={{ animationDelay: '0.9s' }}>
             Transforming agriculture with smart solutions that open markets, boost productivity, and secure brighter futures.
            </p>
            <div className={`hero-cta ${isLoaded ? 'fade-in-up' : ''}`} style={{ animationDelay: '1.1s' }}>
              <a href="/farmer-dashboard">
              <button className="secondary-cta">Get Started <i className='fas fa-arrow-right'></i></button></a>
            </div>
            <div className="produce-cta">
              <span>
                <img src={pineapple} alt="" />
              </span>
              <span>
                <img src={onions} alt="" />
              </span>
              <span>
                <img src={coacoa} alt="" />
              </span>
              <span>
                <img src={yam} alt="" />
              </span>
              <p>Wide Range of Products</p>
            </div>
          </div>
        </div>
        <div className="image-content">
          <div 
            className='phone-box' 
            style={{ backgroundImage: `url(${phonCase})`, backgroundSize: 'cover', backgroundPosition: 'center top' }} 
          >
            <div className="absolute-blocks">
              <div className="block1">
                <span>
                  <h2>Yellow Pepper</h2>
                  <p>+2</p>
                </span>
                <strong>
                  ₦2,000
                </strong>
              </div>
              <div className="block1 bl2">
                <span>
                  <h2>Tomatoe</h2>
                  <p>+10</p>
                </span>
                <strong>
                  ₦10,000
                </strong>
              </div>
            </div>
            <img 
              className="phoneimg" 
              src={phoneImages[currentImageIndex]} 
              alt="" 
              style={{ transition: 'opacity 0.5s ease', opacity: 1 }} 
            />
          </div>
        </div>
      </div>
    </div>
  );
}